function logConfig({ name, env, config, log, }) {
    if (log) {
        // eslint-disable-next-line no-console
        console.groupCollapsed(`${name} Configuration`);
        // eslint-disable-next-line no-console
        console.log("process.env", env);
        // eslint-disable-next-line no-console
        console.log("config", config);
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
}
export function isConfig(config, { schema, name, }) {
    try {
        schema.validateSync(config);
        return true;
    }
    catch (error) {
        if (error instanceof Error) {
            const message = `${name} Validation Error: ${error.message}`;
            throw new Error(message);
        }
        throw error;
    }
}
export function validateConfig({ name, env, config, schema, }, { log }) {
    logConfig({
        name,
        config,
        env,
        log,
    });
    isConfig(config, {
        schema,
        name,
    });
    return config;
}
//# sourceMappingURL=utils.js.map